module.exports = __webpack_public_path__ + "static/media/living_facility.656cc411.jpg";